export default "__VITE_ASSET__DKOQq7ld__"